/** Official AJ Classic Healthcare brand assets. One source of truth for every surface. */

const MARK_PATH = "M26 8h12v18h18v12H38v18H26V38H8V26h18z";
const PULSE = "M10 32h11l3.5-9 4.5 18 4-13 3 4h16";

/** Square app mark. `inverted` renders a white tile with a black glyph. */
export const LogoMark = ({ className = "h-9 w-9", inverted = false, rounded = "rounded-[10px]" }) => (
  <svg viewBox="0 0 64 64" className={`${className} ${rounded} shrink-0`} role="img"
    aria-label="AJ Classic Healthcare" preserveAspectRatio="xMidYMid meet">
    <rect width="64" height="64" rx="15" fill={inverted ? "#FFFFFF" : "#08090C"} />
    <path d={MARK_PATH} fill={inverted ? "#08090C" : "#FFFFFF"} />
    <path d={PULSE} fill="none" stroke={inverted ? "#FFFFFF" : "#08090C"} strokeWidth="3.4"
      strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Full lockup: mark + wordmark. `tone` = dark surfaces ("light" text) or light surfaces. */
export const Logo = ({ tone = "dark", className = "", markClass = "h-9 w-9", compact = false }) => {
  const onDark = tone === "dark";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark className={markClass} inverted={onDark} />
      <span className={`font-ui font-extrabold tracking-tight leading-[1.05] ${compact ? "text-[13px]" : "text-[15px]"}`}>
        <span className={onDark ? "text-white" : "text-[#08090C]"}>AJ CLASSIC</span>
        <span className={onDark ? "text-white/55" : "text-slate-500"}> HEALTHCARE</span>
      </span>
    </span>
  );
};

export const WHATSAPP_NUMBER = "916303822850";
export const WHATSAPP_MESSAGE = "Hi AJ Classic, I'd like to know more about your HMS software";
export const WHATSAPP_LINK =
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const CONTACT = {
  email: "contact@ajclassic.com",
  phone: "+91 6303822850",
  phoneHref: "tel:+916303822850",
  office: "Hyderabad, Telangana, India",
  hours: "10:00 AM – 6:00 PM IST (Mon–Sat)",
};

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.12-.41-2.13-1.31-.79-.7-1.32-1.57-1.47-1.87-.15-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.62-1.5-.85-2.05-.22-.53-.45-.46-.62-.47h-.53c-.18 0-.47.07-.72.34-.25.27-.94.92-.94 2.24s.96 2.6 1.1 2.78c.13.17 1.87 2.98 4.61 4.06 2.28.9 2.74.72 3.24.67.5-.05 1.6-.65 1.83-1.29.22-.63.22-1.17.16-1.29-.07-.12-.25-.2-.55-.35zM12.02 21.8h-.01a9.77 9.77 0 0 1-4.98-1.36l-.36-.21-3.7.97.99-3.62-.23-.37a9.76 9.76 0 0 1-1.5-5.2c0-5.4 4.4-9.79 9.8-9.79 2.62 0 5.07 1.02 6.92 2.87a9.72 9.72 0 0 1 2.86 6.93c0 5.4-4.4 9.78-9.79 9.78zM20.5 3.49A11.7 11.7 0 0 0 12.02 0C5.55 0 .28 5.26.28 11.73c0 2.06.54 4.08 1.56 5.86L.06 24l6.56-1.72a11.7 11.7 0 0 0 5.4 1.38h.01c6.46 0 11.73-5.26 11.73-11.73 0-3.13-1.22-6.08-3.44-8.3z" />
  </svg>
);
